export default __webpack_public_path__ + "static/media/106.8f894fa5.gif";